type ToastVariant = 'default' | 'destructive';

interface ToastOptions {
  title?: string;
  description: string;
  variant?: ToastVariant;
}

export const toast = (options: ToastOptions) => {
  const { title, description, variant = 'default' } = options;
  
  // For now, we'll use a simple alert
  // In a real app, you'd want to use a proper toast library
  const prefix = variant === 'destructive' ? '❌ ' : '✅ ';
  const message = title ? `${title}\n${description}` : description;
  alert(prefix + message);
};
